/**
 * URL utilities for resolving backend asset URLs
 */
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Resolve a relative upload path to a full URL
 * e.g., "/uploads/logos/abc.webp" -> "http://localhost:3001/uploads/logos/abc.webp"
 *
 * @param {string|null} path - Relative path from the backend
 * @returns {string|null} Full URL or null
 */
export function resolveUploadUrl(path) {
  if (!path) return null;
  // If already absolute, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${API_URL}${path}`;
}
